// Frans (fr-FR), Réglages · Notifications (0038_meldingen): zelfde vorm als pushApp.nl.ts.
// Tu-vorm, zoals de rest van de Franse ouderapp. De server herkent gevoelige woorden in het
// Nederlands, Engels en Turks (packages/domain/src/push/sensitive.ts); de uitleg zegt dat eerlijk.
export const appPushFr = {
    title: 'Notifications',
    subtitle: 'De petits rappels sur ton téléphone. Tu choisis ce que tu reçois.',
    settingsBody: 'Rappels, trajets et messages sur ton téléphone',
    device: {
        title: 'Sur cet appareil',
        on: 'Les notifications sont activées sur cet appareil.',
        off: 'Les notifications sont encore désactivées sur cet appareil.',
        turnOn: 'Activer les notifications',
        turnOff: 'Désactiver sur cet appareil',
        test: 'Envoyer une notification test',
        testSent: 'Notification test envoyée. Elle arrive dans un instant.',
        testNone: 'Aucun téléphone n’est encore inscrit.',
        testOff: 'L’envoi est désactivé sur ce serveur.',
        turnedOn: 'Notifications activées',
        turnedOff: 'Notifications désactivées sur cet appareil',
        denied: 'Ton navigateur bloque les notifications d’AMUMIN. Autorise-les dans les réglages de ton navigateur ou de ton téléphone, puis reviens ici.',
        unsupported: 'Ce navigateur ne peut pas recevoir de notifications.',
        nativeApp: 'Les notifications n’arrivent pas encore dans l’app iPhone d’AMUMIN. Tu les veux dès maintenant ? Ouvre AMUMIN dans Safari et ajoute-le à ton écran d’accueil.',
        unavailable: 'Les notifications ne sont pas encore configurées. Réessaie plus tard.',
        needsInstall: 'Sur iPhone et iPad, les notifications n’arrivent que si AMUMIN est sur ton écran d’accueil. Ajoute-le d’abord (voir ci-dessous), puis ouvre AMUMIN depuis ton écran d’accueil.',
        notAllowedChild: 'Un parent active les notifications pour toi.',
        inUse: 'Ce navigateur est déjà inscrit pour quelqu’un d’autre de ta famille.',
        nothingChosen: 'Tu n’as rien choisi, aucune notification n’arrivera.',
        loginNote: 'Les notifications arrivent tant que tu es connecté sur cet appareil. Si tu te déconnectes, elles s’arrêtent.',
    },
    install: {
        title: 'Mets AMUMIN sur ton écran d’accueil',
        body: 'Tu ouvres alors AMUMIN d’un seul geste, comme une app. C’est gratuit et tu n’as rien à télécharger.',
        installed: 'AMUMIN est sur ton écran d’accueil.',
        platform: 'Quel appareil ?',
        ios: 'iPhone/iPad',
        android: 'Android',
        desktop: 'Ordinateur',
        iosNote: 'Les notifications fonctionnent à partir d’iOS 16.4, si AMUMIN est sur ton écran d’accueil.',
        androidButton: 'Installer AMUMIN',
        desktopButton: 'Installer AMUMIN',
    },
    kinds: {
        title: 'Que veux-tu recevoir ?',
        autosave: 'Ce que tu coches est enregistré tout de suite.',
        reminders: 'Mes rappels',
        remindersHint: 'Au même moment que l’appel de la tablette.',
        remindersChildren: 'Aussi les rappels de mes enfants',
        rides: 'Trajets',
        ridesHint: '« Qui dépose Yakub demain à 08:15 ? » et qui reprend un trajet.',
        approvals: 'Ce qui attend mon oui',
        approvalsHint: 'Regroupé en une notification, au plus une fois par demi-heure.',
        messages: 'Nouveaux messages',
        departure: 'C’est l’heure de partir',
        departureHint: 'Si le rendez-vous a un temps de trajet.',
        summary: 'Résumé du jour',
        summaryHint: 'Chaque jour, un court résumé de l’agenda.',
        summaryAt: 'À',
    },
    quiet: {
        title: 'Heures calmes',
        toggle: 'Pas de notifications pendant les heures calmes',
        from: 'De',
        to: 'À',
        note: 'Les rappels que tu as créés pour toi-même passent quand même.',
    },
    discreet: {
        title: 'Discret sur l’écran verrouillé',
        body: 'Les notifications passent chiffrées par le service d’Apple, Google, Mozilla ou Microsoft. Ce service ne peut pas les lire. Mais sur ton écran verrouillé, tout le monde peut les voir. C’est pourquoi il n’affiche par défaut que « AMUMIN » et le type de notification.',
        all: 'Tout discret',
        allHint: 'Activé par défaut. Tu vois seulement « AMUMIN » avec « Un rappel », « Quelque chose sur les trajets », « Quelque chose attend ton oui » ou « Un nouveau message ». Si tu le désactives, tu vois les détails : le titre, les prénoms, l’heure, le lieu et le texte d’un message.',
        sensitive: 'Foi, santé et école discrètes',
        sensitiveHint: 'Même avec les détails : si nous reconnaissons à l’icône ou à certains mots (en néerlandais, en anglais et en turc) qu’un rendez-vous, un rappel ou un message concerne la santé, la foi ou l’école, la notification reste discrète. Aucune liste de mots n’est complète : dans le doute, laisse tout discret.',
    },
    children: {
        title: 'Enfants',
        body: 'Un enfant avec son propre compte peut aussi recevoir des notifications, si tu es d’accord. Par défaut, c’est désactivé.',
        allow: 'Notifications pour {name}',
        noLogin: '{name} n’a pas de compte à lui.',
        none: 'Il n’y a pas encore d’enfants dans ta famille.',
        toastOn: '{name} peut maintenant recevoir des notifications',
        toastOff: '{name} ne reçoit plus de notifications',
    },
    devices: {
        title: 'Tes téléphones et navigateurs',
        none: 'Aucun téléphone ni navigateur inscrit pour l’instant.',
        since: 'Inscrit le {date}',
        lastUsed: 'Dernière notification {date}',
        error: 'La dernière notification n’est pas arrivée.',
        remove: 'Retirer',
        removeLabel: 'Retirer {name}',
        removed: 'Retiré',
        thisOne: 'Celui-ci',
    },
    save: 'Enregistrer',
    saved: 'Enregistré',
    offTitle: 'Les notifications sont désactivées',
    offBody: 'Les notifications sont désactivées pour ta famille. Un parent les active dans Modules.',
};
//# sourceMappingURL=pushApp.fr.js.map